<template>
  <div class="offer-page-container">
    <div class="band" />
    <div class="offers-header">
      <img :src="`/images/triangle/triRewards_logo_${this.language}.svg`" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";

export default {
  name: "OffersPageHeader",
  mixins: [blockElementMixin],
  computed: {
    ...mapGetters(['language']),
  },
}
</script>

<style lang="scss" scoped>
.offer-page-container{
  position: relative;
  width: 100%;

  .band{
    background-color: #78CCC7;;
    height:0.5em;
  }
  .offers-header{
    height: 30%;
    padding: 0.5em;
    img{
      margin: 0.5em 0;
      max-width: 280px;
    }
  }
}
</style>

